/**
 * [Archies 2026-08-23] Soft-navigation page-view re-emitter.
 *
 * WHY: Horizon's combined-listing colour swatches, collection filter/sort, and pagination update the URL
 * via the History API + Section Rendering WITHOUT a full document reload, so Shopify's native page-view
 * beacon (`trekkie_storefront_page_view`) never fires for them. Shopify counts a session with only ONE
 * page-view beacon as a BOUNCE — so in-place colour/filter/paging browsing was mis-counted as bounces vs a
 * full-reload theme (Ella, whose swatches are <a> links = a fresh page view each time). That inflated
 * Horizon's *measured* bounce with no real UX difference (proven 2026-08-23: swatch swap on Horizon =
 * soft-nav, 0 page_viewed; on Ella = full reload, page_viewed fires). Revenue/CVR unaffected (checkout
 * beacons fire normally) — this is purely a measurement gap on the browse path.
 *
 * FIX: on each soft-nav URL change, re-fire the native page view. Verified that ShopifyAnalytics.lib.page()
 * emits `trekkie_storefront_page_view/1.2` — the exact schema a full load fires. These are page views that
 * genuinely happened (the URL really changed to a new product/collection state) — the same ones Ella logs
 * via full reload — so the data becomes accurate, not inflated. Bonus: also restores these page views to
 * app pixels (Meta/Klaviyo/GA4) that miss them today.
 *
 * Upgrade-safe -ext; pure analytics hook (no UX/ADA/CLS impact). Excludes pure ?variant= changes (size
 * selection on the same product page = not a new page view).
 */
(function () {
  if (window.__archiesSoftNavPageview) return;
  window.__archiesSoftNavPageview = true;

  var lastUrl = location.pathname + location.search;
  var debounceTimer = null;

  function firePageView() {
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.lib && typeof ShopifyAnalytics.lib.page === 'function') {
        ShopifyAnalytics.lib.page();
      }
    } catch (e) {
      /* best effort — never break navigation over an analytics call */
    }
  }

  // A soft-nav is a new page view when the PATH changes (colour-swatch swap, category nav) OR a navigation
  // query param changes (filter.* / sort_by / page / q). A pure ?variant= change (size pick on the same
  // product) is NOT a new page, so it's excluded — matching what a full-reload theme would/wouldn't log.
  function isNewPageView(prevUrl, nextUrl) {
    try {
      var a = new URL(prevUrl, location.origin);
      var b = new URL(nextUrl, location.origin);
      if (a.pathname !== b.pathname) return true;
      var keys = {};
      a.searchParams.forEach(function (v, k) { keys[k] = true; });
      b.searchParams.forEach(function (v, k) { keys[k] = true; });
      for (var k in keys) {
        if (k === 'variant' || k === 'cb') continue; // size selection / cache-buster — not a page change
        if (a.searchParams.get(k) !== b.searchParams.get(k)) return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  function onUrlMaybeChanged() {
    var now = location.pathname + location.search;
    if (now === lastUrl) return;
    var counts = isNewPageView(lastUrl, now);
    lastUrl = now;
    if (!counts) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(firePageView, 300); // collapse rapid multi-pushState of one action into one view
  }

  // Wrap the History API so every soft navigation is caught (facets.js, paginated-list.js,
  // collection-pills-ext.js, and the combined-listing swatch morph all pushState/replaceState).
  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    if (typeof original !== 'function') return;
    history[method] = function () {
      var result = original.apply(this, arguments);
      try { onUrlMaybeChanged(); } catch (e) {}
      return result;
    };
  });
  window.addEventListener('popstate', onUrlMaybeChanged);
})();
